import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { GridOptions } from "ag-grid/main";

import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

import {
  AgGridUtility,
  EDIT_BTN,
  NonComplianceSummary,
  DOUBLE_ROW_HEADER,
  Role,
  AUDIT_BTN,
  AUDIT_ENTITY_ID,
  AUDIT_ENTITY_TYPE,
  AUDIT_ENTITY_COLUMN_DEFS,
  AUDIT_PAGE_TITLE,
  PAGE_ID,
  VIEW_BTN
} from '../shared';
import { CommonUtility, ServerConstantsService, DataService, APP_DATE_FORMAT } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import {DashboardType} from "../shared/model/dashboardType";


@Component({
  selector: 'app-non-compliance-summary',
  templateUrl: './non-compliance-summary.component.html',
  styleUrls: ['./non-compliance-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class NonComplianceSummaryComponent implements OnInit {

  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE
  PAGE_ID: string = PAGE_ID

  DOUBLE_ROW_HEADER =DOUBLE_ROW_HEADER;

  ncSummaryResponse: NonComplianceSummary = new NonComplianceSummary();
  ncSummaryRequest: NonComplianceSummary = new NonComplianceSummary();

  referralId: string = '';
  wpPersonId: string = '';
  roles: Role[];

  programArray : any[];
  nonComplianceReasonDesc : any[];
  participationFailedArray :any[];
  goodCauseYesNoArray :any[];

  programMap:any;
  participationFailedMap:any;
  verification: any;
  goodCauseYesNoMap:any;
  nonComplianceReasonDescMap: any;
  userActionNotificationsMap: any;
  verificationMap: any;

  private programJson: any;
  verificationJson: any;
  nonComplianceReasonDescJson: any;
  goodCauseYesNoArrayJson: any;

  ServerConstants: any;
  refData: any;
  sharedData: any;
  request:any;

  error: Boolean = false;
  noData: Boolean = false;
  showAddButton:Boolean = false;
  nonCompService:Boolean = false;
  showData:Boolean = true;
  gridOptions: GridOptions;
  gridApi: any;
  tabIndex:any = "-1";

  private _success = new Subject<string>();
  successMessage: string;

  private _danger = new Subject<string>();
  errorMessage: string;
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  EDIT_BTN:string = EDIT_BTN;
  private reasons: any;

  /*Grid Table*/
  columnDefs: any;
  context: any;

  pageInfo: any;

  auditColumnDefs: any; //audit
  index:any;
  providerId : any;

  isSystemCoordinator: Boolean = false;
  tabToNextCell:any;
  firstTime: Boolean = true;
  isWorker: Boolean = false;

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('NCMPL') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.sharedData = this.dataService.getSharedDataObject();
    this.index = this.dataService.getSharedDataObject().get("NCMPL").innerNavPages.find(x=> x.pageId === 'WCNSU');
    if(this.index.readOnly == true){
      this.tabIndex = "0";
    }
    /* set global values for page */
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.providerId = this.sharedData.get('providerId');

    this.dataService.removeValueFromSharedDataMap("nonCoopId");
    this.ncSummaryRequest = new NonComplianceSummary();
    this.ncSummaryRequest.referralId = parseInt(this.referralId);
    this.ncSummaryRequest.personId =parseInt(this.wpPersonId);
    this.request = this.ncSummaryRequest ;
    this.ncSummaryResponse.wpNonComplianceList =[];
    /* Load Reference Tables*/

    this.parseRefTableData();


    this.nonCompService = false;
    this.load(this.request);
    this.getColumnDefinitions();
    // Audit Method
    this.auditColumnDefinations();

    this.roles = this.sharedData.get('roles');

    //TODO Uncomment when verified in AWS
    this.pageInfo = this.sharedData.get('NCMPL').innerNavPages.find(x=>x.pageId == "WCNSU");
    this.userAccess();

    //this.pageInfo = this.sharedData.get('WCNCS');
    //this.pageInfoUserAccess();

  }

  userAccess(){
    /*
    * Non Compliance Section is write only for role Provider (5) so ADD NEW is only enabled for Provider role
    * */

    for( const role of this.roles){
      if( role.id === 4  ){
        this.isSystemCoordinator = true;
      }

      if( role.id === 5  ){
        this.isWorker = false;
      } else {
        this.isWorker = true;
      }

    }
  }


  pageInfoUserAccess(){
    if(this.pageInfo.readOnly === false){
      this.showAddButton = true;
    }else{
      this.showAddButton = false;
    }
  }


  load(request){
    this.http.post<NonComplianceSummary>( this.ServerConstants.NC_SERVER_API_URL + '/ncsummary/load', request ).subscribe(
      (data) => {
        if(data.hasOwnProperty('errorCode')){
          //Display failure message
          this.nonCompService = false;
          this.notificationService.error('Non-Compliance', this.userActionNotificationsMap.ERROR);
          this.noData = true;
          this.showAddButton = false;
        }else{
          this.nonCompService = true;
          if (data.wpNonComplianceList !=null && data.wpNonComplianceList.length > 0 ){
            this.ncSummaryResponse = new NonComplianceSummary();
            this.ncSummaryResponse = data;
          }else{
            this.ncSummaryResponse = new NonComplianceSummary();
            this.ncSummaryResponse.wpNonComplianceList=[];
            this.noData = true;
            this.showAddButton= true;
            this.showData = false;
          }
        }
      },response => {
        this.error = true;
        this.showAddButton = false;
        this.nonCompService = false;
        this.notificationService.error('Non-Compliance', this.userActionNotificationsMap.ERROR);
      },() => {
        this.error = false;
      });
  }

  getColumnDefinitions() {
    this.columnDefs = [
      { headerName: 'Discovery Date',
        field: 'nonCoopDiscoveryDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatDates,

        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
      },
      {
        headerName: 'Non-Compliance Month',
        field: 'nonCoopMonthDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatDateToMonthAndYear,
        width: 230,
        filterParams: {
          comparator: this.agGridUtility.filterMonthYear,
        },
      },
      {
        headerName: 'Reason',
        field: "nonComplianceReasonCd",
        refData: this.nonComplianceReasonDescJson,

        cellStyle: {'white-space': 'normal'},
        valueGetter: this.getReasonCd

      },
      {
        headerName: 'Program',
        field: "programCd",
        refData: this.programJson,

        valueGetter: this.getProgramCd,
        cellStyle: {'white-space': 'normal'},
      },
      {
        headerName: 'Good Cause Authorized?',
        field: 'goodCauseAuthorizedCd',
        refData: this.verificationJson,

        valueGetter: this.getAuthorizedCd,
        cellStyle: {'white-space': 'normal'},
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        cellStyle: {'white-space': 'normal'},
        width: 120,
        suppressFilter: true,
        suppressSorting: true
      },
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this,
    };
  }

  auditColumnDefinations() {
    this.auditColumnDefs = [
      {
        headerName: 'Discovery Date',
        field: 'nonCoopDiscoveryDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'Non-Compliance Status',
        field: '',
        valueGetter: this.getNonCompStatus,
        tooltip: this.getNonCompStatus
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'lastModifiedDate',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime,
      },
      {
        headerName: 'Reason',
        field: "nonComplianceReasonCd",
        refData: this.nonComplianceReasonDescJson,
        tooltip: (params) => {
          const nonComReasonCodeMap = params.context.nonComplianceReasonDescJson;
          const nonComReasonCode = params.data.nonComplianceReasonCd;
          const nonComReason = nonComReasonCodeMap[nonComReasonCode]
          return nonComReason;
        }
      },
      {
        headerName: 'Good Cause Authorized',
        field: 'goodCauseAuthorizedCd',
        refData: this.verificationJson,
        tooltip: (params) => {
          const verificationMap = params.context.verificationJson;
          const verificationCode = params.data.goodCauseAuthorizedCd;
          const verification = verificationMap[verificationCode]
          return verification;
        }
      }
    ];


  }

  getNonCompStatus(params) {
    let nonCompStatus;
    if (params.data.goodCauseAuthorizedCd === "G" || params.data.goodCauseAuthorizedCd === "D") {
      nonCompStatus = 'Complete';
    } else {
      nonCompStatus = 'In Progress';
    }
    return nonCompStatus;
  }

  getReasonCd(params){
    const that = params.context.component;
    let reasonName = that.convertCode(that.nonComplianceReasonDescMap, params.data.nonComplianceReasonCd);
    if(params.data.nonComplianceReasonCd == undefined){
      reasonName = "";
    }
    return reasonName;
  }

  getProgramCd(params) {
    const that = params.context.component;
    let programName = that.convertCode(that.programMap, params.data.programCd);
    if(params.data.programCd == undefined){
      programName = "";
    }
    return programName;
  }

  getAuthorizedCd(params) {
    const that = params.context.component;
    let authorizedName = that.convertCode(that.verificationMap, params.data.goodCauseAuthorizedCd);
    if(authorizedName == undefined){
      authorizedName = "";
    }
    return authorizedName;
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  getEditButton(params) {
    const that = params.context.component;
    const page = that.dataService.sharedDataMap;
    const pageId = page.get("NCMPL").pageId
    const divRow = document.createElement('div');
    var image;

    divRow.setAttribute("class", "row");

    /*if( (that.providerId === null || that.providerId === undefined) && (params.data.goodCauseAuthorizedCd === "" || params.data.goodCauseAuthorizedCd === null) ){
      image = EDIT_BTN;
    }
    else{
      image = VIEW_BTN;
    }*/

    image = EDIT_BTN;

    // Edit Element
    const element = document.createElement('a');
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('nonCoopId', params.data.id);
      that.router.navigate(['task/noncomplianceSummary/noncompliance']);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
      that.dataService.addValueToSharedDataMap('nonCoopId', params.data.id);
      that.router.navigate(['task/noncomplianceSummary/noncompliance']);
      }
      else if(event.keyCode == 9){
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }
    });
    element.setAttribute("tabindex", "0");
    const divCol1 = document.createElement('div');
    divCol1.setAttribute("class", "col-2 right-margin-1");
    divCol1.appendChild(element);

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.nc.model.WpNonCompliance');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Non-Compliance Audit');
      that.dataService.addValueToSharedDataMap(that.PAGE_ID, pageId);
      that.router.navigate(['/task/noncomplianceSummary/auditHistory']);
    });
    auditElement.addEventListener('keydown', (event) => {
      if(event.keyCode === 13 || event.keyCode === 32) {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.nc.model.WpNonCompliance');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Non-Compliance Audit');
      that.dataService.addValueToSharedDataMap(that.PAGE_ID, pageId);
      that.router.navigate(['/task/noncomplianceSummary/auditHistory']);
      }
    });

    auditElement.setAttribute("tabindex", "0");
    const divCol2 = document.createElement('div');
    divCol2.setAttribute("class", "col-1");
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);
    return divRow;
  }

  editNonCompliance(wpReferralId, wpPersonId, ncId){
    this.dataService.addValueToSharedDataMap("nonCoopId", ncId);
    this.router.navigate(['task/noncomplianceSummary/noncompliance']);
  }

  addNonCompliance(wpReferralId, wpPersonId){
    this.router.navigate(['task/noncomplianceSummary/noncompliance']);
  }

  parseRefTableData(){
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));

    this.programArray = this.data.getValueFromSharedDataMap("ProgramName");
    this.participationFailedArray = this.data.getValueFromSharedDataMap("failedToComplyNC");
    this.goodCauseYesNoArray = this.data.getValueFromSharedDataMap("YESNO");
    this.nonComplianceReasonDesc = this.data.getValueFromSharedDataMap("NonCompReasonDesc");
    this.data.getValueFromSharedDataMap("ExemptionReasonsDesc").forEach((element)=>{
      if(element.value != undefined){
        this.nonComplianceReasonDesc.push(element);
      }
    });
    this.verification = this.data.getValueFromSharedDataMap("GoodCauseReasonDesc");
    this.nonComplianceReasonDescMap = this.commonUtil.createMapFromList(this.nonComplianceReasonDesc );
    this.programMap = this.commonUtil.createMapFromList(this.programArray);
    this.participationFailedMap = this.commonUtil.createMapFromList(this.participationFailedArray);
    this.goodCauseYesNoMap = this.commonUtil.createMapFromList(this.goodCauseYesNoArray);
    this.verificationMap = this.commonUtil.createMapFromList(this.verification );

    this.programJson = this.commonUtil.createNativeMapFromList(this.programArray);
    this.nonComplianceReasonDescJson = this.commonUtil.createNativeMapFromList(this.nonComplianceReasonDesc);
    this.goodCauseYesNoArrayJson = this.commonUtil.createNativeMapFromList(this.goodCauseYesNoArray);
    this.verificationJson = this.commonUtil.createNativeMapFromList(this.verification);

  }

  convertCode(myMap, code){
    if(myMap != undefined){
      return myMap.get(code);
    }
  }

  focusSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if(this.ncSummaryResponse.wpNonComplianceList.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row

    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
  filter(event){
    this.firstTime = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/non-compliance-summary/non-compliance-summary.component.ts